<template>
  <div class="main" :style="{ overflow: 'auto', height: 'calc(90vh - 75px)' }">
    <keep-alive>
      <router-view v-if="keepAlive" />
    </keep-alive>
    <router-view v-if="!keepAlive" />
  </div>
</template>

<script>
export default {
  name: 'RouteView',
  computed: {
    keepAlive() {
      return this.$route.meta.keepAlive;
    }
  }
};
</script>
<style scoped>
.ant-card {
  /* height: 721px; */
  overflow: auto;
}
</style>
